import {useTexture} from '@react-three/drei'

export function useSelectionTextures() {
    const selectionTexture1 = useTexture('./images/select-top-right.png')
    const selectionTexture2 = useTexture('./images/select-top-right2.png')

    // TEXTURE SETTINGS
    // selectionTexture1.flipY = false
    // selectionTexture2.flipY = false

    // selectionTexture1.colorSpace = THREE.SRGBColorSpace
    // selectionTexture2.colorSpace = THREE.SRGBColorSpace

    // selectionTexture1.generateMipmaps = false
    // selectionTexture2.generateMipmaps = false

    // selectionTexture1.magFilter = THREE.NearestFilter
    // selectionTexture2.magFilter = THREE.NearestFilter

    // selectionTexture1.minFilter = THREE.NearestFilter
    // selectionTexture2.minFilter = THREE.NearestFilter

    return {selectionTexture1, selectionTexture2}
}